import { TIME_SAVINGS_CATEGORIES } from '../../../features/AiImpactDashboard/constants';

export const CATEGORY_MAP = TIME_SAVINGS_CATEGORIES.reduce<
	Record<string, string>
>(
	(acc, category) => ({
		...acc,
		[category.key]: category.label,
	}),
	{}
);

export const COMPLEXITY_DESCRIPTIONS: Record<
	string,
	{ title: string; description: string }
> = {
	simple: {
		title: 'Simple',
		description: 'Quickly found an answer using clear input and few resources',
	},
	moderate: {
		title: 'Moderate',
		description: 'Combined multiple data sources or required some reasoning',
	},
	complex: {
		title: 'Complex',
		description:
			'Resolved a multi-step or ambiguous question requiring deep analysis',
	},
};

export const getRatingDescription = (
	score: number
): { title: string; description: string } => {
	if (score < 3) {
		return {
			title: 'Poor',
			description:
				'Response was unclear or inaccurate and may need to be reviewed',
		};
	}
	if (score < 6) {
		return {
			title: 'Acceptable',
			description: 'Response was somewhat accurate but lacked full context',
		};
	}
	return {
		title: 'Good',
		description:
			"Response was clear, accurate, and aligned with the member's intent",
	};
};
